import { render, staticRenderFns } from "./userGroupsList.vue?vue&type=template&id=44d71c03&scoped=true"
import script from "./userGroupsList.vue?vue&type=script&lang=js"
export * from "./userGroupsList.vue?vue&type=script&lang=js"
import style0 from "./userGroupsList.vue?vue&type=style&index=0&id=44d71c03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d71c03",
  null
  
)

export default component.exports